/**
 * Listas largas de un `Dropdown` (cientos de opciones: profesionales, financiadores): scroll virtual con opciones de 36px.
 * Se usa con `virtualScrollerOptions={VIRTUAL_SCROLL}` y `panelClassName={VIRTUAL_PANEL_CLASS}`; el CSS de la clase, que
 * fija ese alto en cada opción, está en `FilterParts.scss`.
 */

/** Alto de cada opción: el del scroll virtual y el del CSS. */
export const VIRTUAL_OPTION_HEIGHT = 36;

export const VIRTUAL_SCROLL = { itemSize: VIRTUAL_OPTION_HEIGHT };

export const VIRTUAL_PANEL_CLASS = 'nv-virtual-panel';
